// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoComponent_container_YJA-P","video":"VideoComponent_video_2vP5R","poster":"VideoComponent_poster_2TRoz","button":"VideoComponent_button_1Qf_R"};